import React from "react";
import PropTypes from "prop-types";
import WildcardSwitch from "layout/dictionary/edit/components/WildcardSwitch";
import { useDispatch, useSelector } from "react-redux";
import { displayWildcardPopup } from "slices/dictionary/dictionarySlice";
import { selectSettings } from "slices/dictionary/selectors";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { dictionaryTurnOffWildcard } from "components/Modal/confModalTypes";
import { termProps } from "layout/dictionary/edit/types";
import { dictionaryTermTypes } from "constants/dictionary";

const Wildcard = ({ isSelected, term, wrapperRef }) => {
  const dispatch = useDispatch();
  const { isEditMode } = useSelector(selectSettings);
  const isEnabled =
    term.dictionaryTermType === dictionaryTermTypes.WILDCARD_EXPRESSION ||
    term.dictionaryTermType === dictionaryTermTypes.REGULAR_EXPRESSION;

  const handleSwitchChange = () => {
    // If term is simple string displays wildcard modal where used will set it up as wildcard
    // If term is wildcard or regexp displays confirmation modal to make term a simple string
    if (!isEnabled) {
      const termWithCaseSensitiveOn = { ...term, caseSensitive: true };
      dispatch(
        displayWildcardPopup({
          displayed: true,
          term: termWithCaseSensitiveOn,
        })
      );
    } else {
      dispatch(
        showModal(
          modalTypes.CONFIRMATION,
          dictionaryTurnOffWildcard(term, dispatch)
        )
      );
    }
  };

  return (
    <div
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
      className="wildcard_cell"
      data-testid="wildcard-cell"
    >
      <WildcardSwitch
        id="switch-id"
        switchRef={wrapperRef}
        isSelected={isSelected}
        currentSwitchState={isEnabled}
        disabled={!isEditMode}
        handleChange={handleSwitchChange}
      />
    </div>
  );
};

Wildcard.propTypes = {
  /**
   * Equals true if this cell is selected.
   */
  isSelected: PropTypes.bool,
  /**
   * The actual term data.
   */
  term: PropTypes.shape(termProps),
  /**
   * A ref which will be used to focus switch element.
   */
  wrapperRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
};

export default Wildcard;
